import styled from 'styled-components';
import { ThemeType } from '../../types/Theme';

const bgCor = ({ alerta, aviso }: { alerta?: boolean; aviso?: boolean }) =>
    alerta
        ? 'rgba(254, 0, 0, 0.15)'
        : aviso
        ? 'rgba(245, 165, 35, 0.20)'
        : 'rgba(42, 132, 78, 0.20)';

const AvisoTrialContainer = styled.div<{ theme: ThemeType; alerta?: boolean; aviso?: boolean }>`
    width: 100%;
    .faixa {
        width: 100%;
        background-color: ${bgCor};
        display: flex;
        gap: 2px;
        align-items: center;
        height: 32px;
        justify-content: center;
        border-bottom-right-radius: 4rem;
        position: relative;
        @media (max-width: 1024px) {
            border-bottom-right-radius: 4rem;
            border-bottom-left-radius: 4rem;
            height: 45px;
        }
        &::before {
            content: '';
            position: absolute;
            width: 20%;
            right: 100%;
            height: 32px;
            background-color: ${bgCor};
        }
        .texto {
            color: ${({ theme, alerta, aviso }) =>
              alerta
              ? '#fe0000'
              : aviso
              ? '#c87a00'
              : theme.mode == "light"
              ? theme.colors.primary
              : theme.colors.secondary};
            line-height: normal;
            padding: 0 15px;
        }
        .link-regularizar {
            color: inherit;
            text-decoration: underline;
            font-weight: bold;
            margin-left: 0.5rem;
            cursor: pointer;
            &:hover {
                opacity: 0.8;
            }
        }
    }
`;

export { AvisoTrialContainer };